import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DetailDisplay, ErrorMessage } from "widgets";

import styles from "./CustomerOrders.module.scss";

import Loader from "shared/Loader/Loader";
import { formatINRCurrency } from "utils/formatINRCurrency";
import { useFetchCustomerOrderDetails } from "store/backend/apiHooks";

const handleOnClickPendingOrder = (orderId, navigate) => {
  navigate(`/orderDetails?order_id=${orderId}`);
};

const CustomerOrders = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [cashierUamId] = useState(localStorage.getItem("cashierUamId"));

  const customerId = searchParams.get("customerId");

  const {
    isPending: isOrderDetailsLoading,
    data: orderDetails,
    error: orderDetailsError,
    isError: isErrorFetchingOrderDetails,
  } = useFetchCustomerOrderDetails(customerId);

  if (isOrderDetailsLoading) {
    return <Loader message="Fetching customer data..." />;
  }

  if (isErrorFetchingOrderDetails) {
    return <ErrorMessage>{orderDetailsError.message}</ErrorMessage>;
  }

  if (Number(cashierUamId) === Number(customerId)) {
    return <ErrorMessage>You cannot search for your own details.</ErrorMessage>;
  }

  return (
    <div className={styles.mainContainer}>
      <button
        type="button"
        className={styles.backButton}
        onClick={() => navigate(-1)}
        aria-label="Go back"
      >
        <ArrowBackIcon fontSize="small" />
        Back
      </button>
      <div className={styles.heading}>Pending Customer Orders</div>
      {orderDetails?.length > 0 ? (
        orderDetails.map((order) => (
          <div
            className={styles.card}
            key={order.order_id}
            onClick={() => handleOnClickPendingOrder(order.order_id, navigate)}
          >
            <DetailDisplay title="Order Id" value={order.order_id} />
            {order.application_number != null && (
              <DetailDisplay
                title="Application No"
                value={order.application_number}
              />
            )}
            <DetailDisplay
              title="Billing Name"
              value={order.address_details.billing_address.recipient_name}
            />
            <DetailDisplay
              title="Billing Phone Number"
              value={order.address_details.billing_address.masked_phone_no}
            />
            <DetailDisplay
              title="Total Order Amount"
              value={formatINRCurrency(order.amount)}
            />
            <DetailDisplay
              title="Pending Amount"
              value={formatINRCurrency(order.amount - order.amount_paid)}
            />
            <DetailDisplay
              title="Order Punch Date"
              value={new Date(order.order_created_date).toLocaleDateString()}
            />
          </div>
        ))
      ) : (
        <ErrorMessage>No pending orders found for this customer.</ErrorMessage>
      )}
    </div>
  );
};

export default CustomerOrders;
